import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-error-page",
    standalone: true,
    imports: [TranslateModule],
    templateUrl: "./error-page.component.html",
})
export class ErrorPageComponent {}
